import { defineMessages } from 'react-intl';

/** i18n for Facebook connect alternatives shown in the multi-method dialog. */
export const facebookConnectMessages = defineMessages({
  standardName: {
    id: 'socialExport.facebook.connect.standardName',
    defaultMessage: 'Facebook',
  },
  standardDescription: {
    id: 'socialExport.facebook.connect.standardDescription',
    defaultMessage: 'Publicar en páginas de Facebook',
  },
  standardPermissions: {
    id: 'socialExport.facebook.connect.standardPermissions',
    defaultMessage:
      'Acceso a páginas. IMPORTANTE: al dar permisos a la aplicación, concedé acceso solamente a la página en la cual se desea publicar.',
  },
  businessName: {
    id: 'socialExport.facebook.connect.businessName',
    defaultMessage: 'Facebook Business',
  },
  businessDescription: {
    id: 'socialExport.facebook.connect.businessDescription',
    defaultMessage: 'Publicar desde cuentas de Facebook Business',
  },
  businessPermissions: {
    id: 'socialExport.facebook.connect.businessPermissions',
    defaultMessage:
      'Acceso a páginas vía Facebook Business. IMPORTANTE: al dar permisos a la aplicación, concedé acceso solamente a la página en la cual se desea publicar.',
  },
});
